const NavList = [
  {
    name: 'Location',
    path: '/location',
    fields: ['capitalCities', 'cities', 'otherLocations']
  },
  {
    name: 'Sector',
    field: 'sector',
    path: '/sector'
  },
  {
    name: 'Category',
    field: 'category',
    path: '/category'
  },
  {
    name: 'Content',
    field: 'content',
    path: '/content',
    child: [
      {
        name: 'TUD+ Exclusive',
        link: '/tud-plus-exclusive'
      },

      {
        name: 'Top Stories',
        link: '/top-stories'
      }
    ]
  },
  {
    name: 'Type',
    field: 'type',
    path: '/type'
  }
];

export default NavList;
